// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import {getAuth,GoogleAuthProvider } from 'firebase/auth';
import {getFirestore} from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0albHFnSPKrTb7SNnygOLTaukFRhENeM",
  authDomain: "letschat-d22cd.firebaseapp.com",
  projectId: "letschat-d22cd",
  storageBucket: "letschat-d22cd.appspot.com",
  messagingSenderId: "87419708194",
  appId: "1:87419708194:web:24b960113ed3be73487b7b",
  measurementId: "G-6165Y2H0VF"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const provider = new GoogleAuthProvider();
export const auth = getAuth(app);
export const db = getFirestore(app);